import { render, staticRenderFns } from "./EModalCarteira.vue?vue&type=template&id=6cd760a1&scoped=true"
import script from "./EModalCarteira.vue?vue&type=script&lang=js"
export * from "./EModalCarteira.vue?vue&type=script&lang=js"
import style0 from "./EModalCarteira.vue?vue&type=style&index=0&id=6cd760a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd760a1",
  null
  
)

export default component.exports